"use client";

import React, { useEffect, useRef, useState } from "react";
import style from "./InnovationWaveText.module.scss";
import Wave from "react-wavify";
import { Canvas } from "@react-three/fiber";
import { PerspectiveCamera } from "@react-three/drei";
import { InnovationDuck } from "./InnovationDuck";
import { useDeviceDetector } from "@/utils/useDeviceDetector";
import CommonDuckWaveScene from "@/components/common/3D/CommonDuckScene/CommonDuckWaveScene";

const InnovationWaveText = ({ messages }) => {
  const waveRef = useRef(null);
  const { isMobile } = useDeviceDetector();

  const [amplitude, setAmplitude] = useState(60);

  useEffect(() => {
    setAmplitude(isMobile ? 25 : 60);
  }, [isMobile]);

  return (
    <section className={style.wrap}>
      {!isMobile && (
        <div className={style.canvasContainer}>
          <Canvas
            style={{
              width: "100%",
              height: "100vh",
              zIndex: 10,
            }}
            className="innovationCanvas"
            data-three="/models/dev.glb"
          >
            <ambientLight></ambientLight>
            <pointLight position={[0, 0, 7.5]} intensity={350}></pointLight>
            <PerspectiveCamera fov={40} makeDefault position={[0, 0, 16]} />
            <InnovationDuck waveRef={waveRef} />
          </Canvas>
        </div>
      )}
      {isMobile && (
        <div
          style={{
            position: "absolute",
            zIndex: 5,
            bottom: 0,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CommonDuckWaveScene wave={waveRef} isInverse />
        </div>
      )}
      <div className={`container`} style={{ zIndex: "2" }}>
        <h2>
          {messages.first_word}
          <span>
            {" "}
            {messages.second_words} {messages.third_words}{" "}
          </span>{" "}
          {messages.fourth_words} {messages.last_words}
        </h2>
      </div>
      <div
        style={{
          width: "100%",
          height: "100%",
          overflow: "hidden",
          position: "absolute",
          zIndex: "1",
          top: "0",
          left: "0",
        }}
      >
        <div
          style={{
            width: "110vw",
            height: "100%",
            transform: "translate(-5vw, 0)",
          }}
          ref={waveRef}
        >
          <Wave
            className={style.wave}
            fill="var(--primary)"
            paused={false}
            style={{
              display: "flex",
              transform: "rotate(180deg)",
              height: "100%",
              width: "100%",
            }}
            options={{
              height: 50,
              amplitude: amplitude,
              speed: 0.2,
              points: 2,
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default InnovationWaveText;

InnovationWaveText.displayName = "InnovationWaveText";
